import cs from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { useMemo } from 'react';
import { Button } from '@/DesignSystem/Component';
import { LINKS } from '@/Module/Core/Constant';
import { useAppSelector } from '@/Module/Store/Hook';
import { SubscriptionDescription } from '@/Module/Subscription/Component';
import { BOX_CLASS_S, BUTTON_COLOR_S, TITLE_COLOR_S } from '@/Module/Subscription/Component/SubscriptionPageContainer/SubscriptionPageNew/SubscriptionCarts';
import type { ISubscriptionPlan } from '@/Module/Subscription/Model/DataModel';
import { selectedSubscriptionV2UserActiveSelector } from '@/Module/Subscription/Store/Selector/selectedSubscriptionV2UserActiveSelector';
const plan: ISubscriptionPlan = {
  details: [],
  color: 'green',
  sortOrder: 0,
  id: 1000,
  duration: undefined,
  subscriptionName: 'اشتراک رایگان',
  subscriptionDescription: 'دسترسی به تمامی محتوای سایت به مدت 3 روز',
  price: {
    id: 10,
    price: 0,
    originalPrice: 0,
    subscriptionPlanId: 1,
    createdUser: 0,
    createdDate: '',
    description: ''
  }
};
const SubscriptionPageFree: FC = () => {
  const isLoggedIn = useAppSelector(state => state.auth.isLoggedIn);
  const router = useRouter();
  const listSubscriptionActive = useAppSelector(state => selectedSubscriptionV2UserActiveSelector(state));
  const title = useMemo(() => {
    if (!isLoggedIn) return 'فعالسازی اشتراک رایگان';
    return listSubscriptionActive.find(subscription => subscription.subscriptionPlanId === 177) ? 'این اشتراک برای شما فعال است.' : 'این اشتراک، قبلا استفاده شده است';
  }, [isLoggedIn, listSubscriptionActive]);
  return <div className={cs(isLoggedIn && ' bg-blackOne !border-blackTwo', BOX_CLASS_S[plan.color], `rounded-md border-[1px] px-4 py-5 flex flex-col `)} data-sentry-component="SubscriptionPageFree" data-sentry-source-file="SubscriptionPageFree.tsx">
      <div className="mb-4 flex flex-row justify-between md:mb-8">
        <div className={cs(isLoggedIn && ' !text-blackFive', TITLE_COLOR_S[plan.color], 'font-bold text-xl ')}>
          {plan.subscriptionName.split('_')[0]}
        </div>
        {isLoggedIn && <div className="self-end rounded-md bg-blackSix p-1 text-sm text-white">غیرقابل تمدید</div>}
      </div>

      <div className="mb-3 mt-0 flex items-center justify-center gap-2 text-center sm:mt-[42px]">
        <span className={cs(`text-3xl font-extrabold `)}>رایـــــگــــان</span>
      </div>
      <div className="flex flex-row items-center justify-center ">
        <span className="ml-2 text-sm text-blackThree"> مدت اعتبار:</span>
        <span className="ml-2 text-sm text-blackThree">3 روز رایگان</span>
      </div>
      <div className="my-3 h-[1px] w-full bg-blackTwo sm:my-6" />
      <ul className={cs(' transition-all duration-200 mb-2 sm:flex-1 h-auto flex-1')}>
        <SubscriptionDescription subscriptionDescription={plan.subscriptionDescription} data-sentry-element="SubscriptionDescription" data-sentry-source-file="SubscriptionPageFree.tsx" />
      </ul>
      <Button href={!isLoggedIn ? `${LINKS.AUTH.LOGIN}?redirectUrl=${encodeURI(router.asPath)}` : ``} as={!isLoggedIn ? Link : 'button'} disabled={isLoggedIn && true} className={cs(isLoggedIn && '!text-blackThree !border-blackThree !bg-blackTwo', BUTTON_COLOR_S[plan.color], 'w-full self-end border-[1px] font-bold transition-all duration-300 ')} data-sentry-element="Button" data-sentry-source-file="SubscriptionPageFree.tsx">
        {title}
      </Button>
    </div>;
};
export default SubscriptionPageFree;